import * as Accordion from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";
import type { FaqItem } from "../config/faq";
import { useLanguage } from "../i18n/LanguageContext";

export const FAQAccordion = ({ items }: { items: FaqItem[] }) => {
  const { tr } = useLanguage();
  return (
    <Accordion.Root type="single" collapsible className="divide-y divide-sand-200 border-y border-sand-200" data-testid="faq-accordion">
      {items.map((item, i) => (
        <Accordion.Item key={item.id} value={item.id} className="group" data-testid={`faq-item-${item.id}`}>
          <Accordion.Header>
            <Accordion.Trigger className="flex w-full items-start justify-between gap-6 py-6 text-left transition-colors hover:text-clay" data-testid={`faq-trigger-${item.id}`}>
              <span className="flex gap-5">
                <span className="font-display text-sm text-charcoal-400 pt-1">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-display text-lg md:text-xl font-medium">{tr(item.question)}</span>
              </span>
              <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full border border-sand-300 transition-transform duration-300 group-data-[state=open]:rotate-45 group-data-[state=open]:bg-clay group-data-[state=open]:text-cream group-data-[state=open]:border-clay"><Plus className="h-4 w-4" aria-hidden /></span>
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="overflow-hidden data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up" data-testid={`faq-content-${item.id}`}>
            <p className="pb-6 pl-[3.1rem] pr-12 text-base leading-relaxed text-charcoal-500">{tr(item.answer)}</p>
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
};
